import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IDeploymentsPageState {
  activeTab: string;
}

const initialState: IDeploymentsPageState = {
  activeTab: "mcs",
};

const deploymentsPageSlice = createSlice({
  name: "deploymentsPage",
  initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<string>) => {
      state.activeTab = action.payload;
    },
  },
});

export const { setActiveTab } = deploymentsPageSlice.actions;
export const deploymentsPageReducer = deploymentsPageSlice.reducer;
